import Link from 'next/link';
import { Button } from '@/components/ui/button';
import CalendarLink from '@/components/ui/calendar-link';
import { Mail } from 'lucide-react';

interface NavigationProps {
	session: any;
}

export function Navigation({ session }: NavigationProps) {
	return (
		<nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-16">
					<div className="flex items-center space-x-2">
						<Mail className="h-8 w-8 text-emerald-600" />
						<span className="text-xl font-bold text-gray-900">NOS Email</span>
					</div>
					<div className="flex items-center space-x-4">
						<Link href="/login">
							<Button variant="ghost">Login</Button>
						</Link>
						<Link href="/signup">
							<Button className="px-6 py-2 bg-emerald-600 text-white rounded-md font-medium hover:bg-emerald-700 transition-colors">
								Get Started
							</Button>
						</Link>
					</div>
				</div>
			</div>
		</nav>
	);
}
